import { memo } from 'react';

import { type IconComponent } from '@air/design-icons';

import { NullState, type NullStateProps } from '~/components/NullState';

export type NonContributableEmptyStateProps = Partial<Pick<NullStateProps, 'description' | 'title'>> & {
  icon: IconComponent;
};

export const NonContributableEmptyState = memo(
  ({
    description = 'Content your team adds will appear here.',
    title = 'No content yet',
    icon,
  }: NonContributableEmptyStateProps) => (
    <NullState testId="NON_CONTRIBUTABLE_EMPTY_STATE" icon={icon} title={title} description={description} />
  ),
);

NonContributableEmptyState.displayName = 'NonContributableEmptyState';
